import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { Header } from 'src/components'
import { useChangeBackground } from 'src/hooks/useChangeBackground'

import styles from './MenuLayout.module.scss'
import { useTitles } from './hooks/useTitles'

interface Props {
  className?: string
}

const MenuLayoutPage: React.FC<Props> = ({ className }) => {
  const TITLES = useTitles()
  const { pathname } = useLocation()
  useChangeBackground(styles.background)

  return (
    <div className={className}>
      <Header variant='settings' setting={TITLES[pathname.split('/')[2] as keyof typeof TITLES]} />

      <Outlet />
    </div>
  )
}

export default MenuLayoutPage
